import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';

import { IconsComponent } from './icons.component';

@NgModule({
  declarations: [IconsComponent],
  exports: [IconsComponent],
  imports: [CommonModule, HttpClientModule]
})
export class IconsModule {}
